export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', description: '激情燃烧的战斗与冒险，点燃你的热血之魂' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的爱情故事，心动每一刻' },
  { slug: 'xuanhuan', name: '玄幻', icon: 'ri-magic-line', description: '奇幻瑰丽的异世界，无限想象空间' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '爆笑不断的欢乐日常，笑到停不下来' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的推理谜题，烧脑解谜之旅' },
  { slug: 'xiaoyuan', name: '校园', icon: 'ri-building-line', description: '青春洋溢的校园生活，回忆那些年' },
  { slug: 'dushi', name: '都市', icon: 'ri-building-2-line', description: '现代都市的爱恨情仇，人间百态尽在其中' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line', description: '未来科技的无限可能，探索未知世界' },
];